import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {DmsDataGrid} from '@dms/shared';

export function WarehousesSupplierOrderTypes() {
  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.warehouse.labels.supplierOrderTypes'),
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.supplierOrderTypes')} />
      <SettingsTemplate
        data-testid={testIds.settings.warehousesSupplierOrderTypes('template')}
        header={header}
      >
        <DmsDataGrid
          gridCode="warehouse-supplier-order-type"
          emptyState={{
            headline: i18n.t('general.labels.noData'),
          }}
          data-testid={testIds.settings.warehousesSupplierOrderTypes(
            'warehouse-supplier-order-type'
          )}
        />
      </SettingsTemplate>
    </>
  );
}
